import { ref } from "vue";
import appApi from "@/services/api";
import { showToast, exceptionRequestMsg } from "@/assets/js/util";
import { useRouter } from "vue-router";
import { useLoginStore } from "@/store/auth";
import { storeToRefs } from "pinia";

export const useLogin = () => {
  const { userStoreToken } = storeToRefs(useLoginStore());
  const router = useRouter();
  const botonCargando = ref(false);
  const user_id = ref(localStorage.getItem("_id"));
  const user_nombre = ref(localStorage.getItem("_nombre"));
  const user_token = ref(localStorage.getItem("_token"));
  const user_modules = ref(localStorage.getItem("_modulos"));

  const isAuthenticated = () => {
    if (!user_id.value || !user_nombre.value || !user_token.value) {
      return false;
    } else {
      return true;
    }
  };

  const validateCredentials = async () => {
    botonCargando.value = true;
    try {
      const form = document.getElementById("formLogin");
      const formData = new FormData(form);
      const response = await appApi().post(`auth/login`, formData);
      const { status, message, token, user, modulos } = response.data;

      if (!status) {
        showToast(message, "error");
        return;
      }

      const { id, nombre, paterno, materno } = user;
      const nombreUsuario = `${nombre} ${paterno} ${materno}`.trim();

      const userToken = localStorage.setItem("_token", token);
      const userId = localStorage.setItem("_id", id);
      const userNombre = localStorage.setItem("_nombre", nombreUsuario);
      const userModules = localStorage.setItem(
        "_modulos",
        JSON.stringify(modulos)
      );
      
      user_id.value = userId;
      user_nombre.value = userNombre;
      user_token.value = userToken;
      user_modules.value = userModules;
      userStoreToken.value = token;

      router.push({
        name: "cotizacion-rapida",
      });
    } catch (e) {
      console.log(e);
      exceptionRequestMsg(e);
    } finally {
      botonCargando.value = false;
    }
  };

  return {
    botonCargando,
    validateCredentials,
    isAuthenticated,
  };
};
